import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AGENT_MODEL } from '@nrwl/common-lib';
import * as _ from 'lodash';
@Component({
  selector: 'nrwl-agent-details',
  templateUrl: './agent-spec.component.html',
  styleUrls: ['./agent-spec.component.scss']
})
export class AgentSpecComponent implements OnInit {
  dialogData = [];
  deviceCapabilities: any;
  port1: string;
  port2: string;
  badIpValues = ['', '0', '0.0.0.0', '255.255.255.255', '::/0'];
  badSubnetValues = ['', '-1', '0', 'null'];
  capabilityDisplayOrder = [
    'system',
    'phy',
    'software',
    'properties',
    'proxy',
    'upgrade',
    'certificate',
    'timers',
    'diagnostics',
    'serviceMapping'
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any // eslint-disable-line
  ) {}

  ngOnInit(): void {
    this.getAgentSpecInfo();
  }
  getAgentSpecInfo(): void {
    const deviceItem = this.data.data;
    this.deviceCapabilities = deviceItem.capabilities;
    const arrayObject = [];
    if (this.deviceCapabilities) {
      this.deviceCapabilities.system = {
        ...this.deviceCapabilities.system,
        model: deviceItem.model.model,
        version: deviceItem.model.version,
        ...(deviceItem.model.model.indexOf('JMEP') >= 0
          ? { proxy: deviceItem.connections?.[0]?.uri?.split('//')[1] }
          : { agent: deviceItem.connections?.[0]?.uri?.split('//')[1] }),
        'communication mode': deviceItem.comMode ?? 'direct'
      };

      if (this.data.deviceName.includes('QT') || this.data.deviceName.includes('MAP')) {
        this.getPortName();
        for (const item in this.deviceCapabilities) {
          if (this.deviceCapabilities[item].length >= 1) {
            const data = [];
            for (const key in this.deviceCapabilities[item]) {
              if (this.deviceCapabilities[item]) {
                let port;
                if (this.deviceCapabilities[item][key]['phy-id'] === 'p1') {
                  port = this.port1;
                } else {
                  port = this.port2;
                }
                data.push({
                  key: port
                });
                for (const innerKey in this.deviceCapabilities[item][key]) {
                  // Skip if key is 'registrationCode'
                  if (innerKey === 'registrationCode') {
                    continue;
                  }
                  data.push({ key: innerKey, value: this.deviceCapabilities[item][key][innerKey] });
                }
              }
            }
            arrayObject.push({ title: item, info: data });
          } else {
            const data = [];
            for (const key in this.deviceCapabilities[item]) {
              // Skip if key is 'registrationCode'
              if (key === 'registrationCode') {
                continue;
              }
              data.push({ key: key, value: this.deviceCapabilities[item][key] });
            }
            arrayObject.push({ title: item, info: data });
          }
        }
      } else {
        for (const item in this.deviceCapabilities) {
          let orderedPhyObj = [];
          const data = [];
          if (this.data.model === AGENT_MODEL.JMEP_10G && item === 'twampInitiator') {
            continue;
          }

          if (item === 'phy' && this.deviceCapabilities['phy']?.['esam-guid']) {
            const phyInfo = this.deviceCapabilities['phy'];
            orderedPhyObj = [
              { key: 'esam-ip', value: phyInfo?.['esam-ip'] },
              { key: 'esam-guid', value: phyInfo?.['esam-guid'] },
              { key: 'assigned-ip', value: phyInfo?.['assigned-ip'] },
              { key: 'jmep-id', value: phyInfo?.['jmep-id'] },
              { key: 'transceiver-code', value: phyInfo?.['transceiver-code'] },
              { key: 'equipment-mac', value: phyInfo?.['equipment-mac'] },
              { key: 'network-mac', value: phyInfo?.['network-mac'] }
            ];
            if (phyInfo['test-ip'] && typeof phyInfo['test-ip'] !== 'undefined') {
              orderedPhyObj.push({
                key: 'test-ip',
                value: this.badIpValues.includes(phyInfo['test-ip']) ? '' : phyInfo['test-ip']
              });
            }
            if (
              phyInfo['test-vlan-id'] &&
              typeof phyInfo['test-vlan-id'] !== 'undefined' &&
              phyInfo['test-vlan-id'] !== 'null'
            ) {
              orderedPhyObj.push({
                key: 'test-vlan-id',
                value: phyInfo['test-vlan-id'] !== '-1' ? phyInfo['test-vlan-id'] : ''
              });
            }
            if (phyInfo['subnet'] && typeof phyInfo['subnet'] !== 'undefined') {
              orderedPhyObj.push({
                key: 'subnet',
                value: this.badIpValues.includes(phyInfo['subnet']) ? '' : phyInfo['subnet']
              });
            }
            if (
              phyInfo['gateway'] &&
              phyInfo['gateway'] !== 'null' &&
              typeof phyInfo['gateway'] !== 'undefined'
            ) {
              orderedPhyObj.push({
                key: 'gateway',
                value: this.badIpValues.includes(phyInfo['gateway']) ? '' : phyInfo['gateway']
              });
            }
            arrayObject.push({ title: 'phy', info: orderedPhyObj });
            continue;
          }
          for (const key in this.deviceCapabilities[item]) {
            // Skip if key is 'registrationCode'
            if (key === 'registrationCode') {
              continue;
            }
            data.push({ key: key, value: this.deviceCapabilities[item][key] });
          }
          arrayObject.push({ title: item, info: data });
        }
      }
    }
    this.dialogData = _.sortBy(arrayObject, item => {
      const index = _.indexOf(this.capabilityDisplayOrder, item.title);
      return index === -1 ? this.capabilityDisplayOrder.length : index;
    });
  }
  getPortName(): void {
    if (this.deviceCapabilities['phy-list']) {
      if (this.deviceCapabilities['phy-list'][0]?.name) {
        this.port1 = this.deviceCapabilities['phy-list'][0].name;
      }
      if (this.deviceCapabilities['phy-list'][1]?.name) {
        this.port2 = this.deviceCapabilities['phy-list'][1].name;
      }
    }
  }
}
